/*!*
 * request 用于发送及初步处理请求，
 * 包括，处理未登录，无权限，基本操作提示信息，以及loading动画，
 * loading 目前只能用默认配置 loadingConfig
 */
import axios from 'axios'
import _ from 'lodash'
import { Notification, Loading } from 'element-ui'
import { getToken, removeToken, setToken } from '../utils/token'
import { isType } from '../utils/is-type'

import {
  log,
  headersKeysLowerCase,
  hasNextPage,
  hasPageCount,
  getTotalCount
} from './index'
import { AXIOS_TIMEOUT, LOADING_CONFIG, ACCESS_TOKEN_KEY } from '../config'
import { progress } from './progress'
import { addWatermark } from './req-res-validate'
import {goLoginPage} from '@/utils/go-login-page'

const ERROR_MESSAGE_MAPS = {
  400: '请求错误',
  401: '未授权，请登录',
  // 402: '请求错误',
  403: '拒绝访问',
  404: '请求地址出错',
  408: '请求超时',
  500: '服务器内部错误',
  501: '服务未实现',
  502: '网关错误',
  503: '服务不可用',
  504: '网关超时',
  505: 'HTTP版本不受支持'
}

// let loginOutMessageStatus = 0 // 0 ready，1 pending, 2 done
// 处理未登录状态
const processLoginOut = (resp) => {
  // if (router.currentRoute.name !== 'Login') {
  //   store.commit('common/goLoginPage')
  // }
  removeToken()
  goLoginPage()
  // if (loginOutMessageStatus > 0) {
  //   return
  // }
  // loginOutMessageStatus = 1
  // MessageBox.confirm('登录已过期，请重新登录，是否继续?', '提示', {
  //   confirmButtonText: '确定',
  //   cancelButtonText: '取消',
  //   type: 'info'
  // }).then(() => {
  //   loginOutMessageStatus = 2
  //   if (router.currentRoute.name !== 'Login') {
  //     router.push({name: 'Login', query: {from: getPath()}})
  //   }
  // }).catch(() => {
  //   loginOutMessageStatus = 0
  // })
}

const methodsMap = {
  delete: '删除',
  patch: '修改',
  put: '修改'
}
// 自定义操作
const actionMap = {
  add: '添加',
  set: '设置',
  edit: '修改'
}

/* 处理响应消息 */
const processResponseMessage = (resp) => {
  if (!resp) return
  const data = resp.data
  const dataMessage = data.message || ''
  // const dataCode = data.code
  // const dataStatus = data.status
  let config = resp.config
  let method = config.method
  let action = config.action
  let status = resp.status
  let methodText = methodsMap[method]
  let actionText = actionMap[action]
  // 未登录
  if (status === 401) {
    processLoginOut(resp)
    return
  }
  // 静默模式，不显示处理消息
  if (config.silent == 1) return
  // 优先显示用户操作提示{actionText}， 再提示请求方法操作提示 {methodText}
  if (actionText) {
    if (status >= 200 && status < 300) {
      Notification({
        title: '提示',
        message: `${actionText}成功！${dataMessage}`,
        type: 'success'
      })
    } else {
      Notification({
        title: '提示',
        message: `${actionText}失败！${dataMessage}`,
        type: 'error'
      })
    }
    return
  }
  if (methodText) {
    if (status >= 200 && status < 300) {
      Notification({
        title: '提示',
        message: `${methodText}成功！${dataMessage}`,
        type: 'success'
      })
    } else {
      Notification({
        title: '提示',
        message: `${methodText}失败！${dataMessage}`,
        type: 'error'
      })
    }
    return
  }

  // 默认使用使用后台返回提示
  if (dataMessage && _.isString(dataMessage) && status !== 202) {
    Notification({
      title: '提示',
      message: `${dataMessage}`,
      type: 'error'
    })
  }
  // 显示空数据消息
  if (status === 202 && config.emptyMsg == 1) {
    Notification({
      title: '提示',
      message: `${dataMessage || '数据为空'}`,
      type: 'error'
    })
  }
}

const processResponseError = (error) => {
  if (error.status && ERROR_MESSAGE_MAPS[error.status]) {
    Notification({
      title: '提示',
      message: ERROR_MESSAGE_MAPS[error.status],
      type: 'error'
    })
  }
}

// 创建axios实例 application/json; charset=UTF-8
// const CONTENT_TYPE = { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
const CONTENT_TYPE = { 'Content-Type': 'application/json; charset=UTF-8' }
const service = axios.create({
  baseURL: '', // api的base_url
  timeout: AXIOS_TIMEOUT,
  headers: { // axios.defaults.headers
    common: { 'Accept': 'application/json, text/plain, */*' },
    post: CONTENT_TYPE,
    put: CONTENT_TYPE,
    patch: CONTENT_TYPE
  },
  // `onUploadProgress` allows handling of progress events for uploads
  onUploadProgress: function (progressEvent) {
    // Do whatever you want with the native progress event
  },
  // `onDownloadProgress` allows handling of progress events for downloads
  onDownloadProgress: function (progressEvent) {
    // Do whatever you want with the native progress event
  },
  validateStatus (status) {
    return status >= 200 && status < 300 && status !== 202 // 202 空数据
  },

  // `transformRequest` allows changes to the request data before it is sent to the server
  // This is only applicable for request methods 'PUT', 'POST', and 'PATCH'
  // The last function in the array must return a string or an instance of Buffer, ArrayBuffer,
  // FormData or Stream
  // You may modify the headers object.
  transformRequest: [function (data, headers) {
    // Do whatever you want to transform the data
    // 处理token
    let token = getToken()
    if (token) {
      headers['access-token'] = token
    }
    headers['app-type'] = '0'
    return JSON.stringify(data)
  }]

  // `transformResponse` allows changes to the response data to be made before
  // it is passed to then/catch
  // transformResponse: [function (data, header) {
  //   let parsedData = JSON.parse(data)
  //   if (hasPageCount(header) && isType(parsedData, 'object')) {
  //     parsedData.totalCount = getTotalCount(header)
  //     parsedData.hasNextPage = hasNextPage(header)
  //   }
  //   return parsedData
  // }]
})

let globalLoading = []
let loadingWaitTime = 300 // ms
let loadingTimer = []
let loadingTimerLastTimestamp = new Date().getTime()
let loadingConfig = LOADING_CONFIG

const processLoading = () => {
  _.each(loadingTimer, (timer) => {
    clearTimeout(timer)
  })
  _.each(globalLoading, (loading) => {
    loading.close()
  })
  loadingTimer = []
  loadingTimerLastTimestamp = new Date().getTime()
  globalLoading = []
}

// 添加到loading队列
const addLoadingQueue = (loading, loadingCfg) => {
  if ((typeof loading === 'string') && loading.indexOf('#') === 0) {
    _.assign(loadingCfg, { target: loading })
  }
  // 请求队列执行时，下一个请求时间间隔如果小于17ms
  // 则立即显示loading，第一个请求时间如果超过 loadingWaitTime才会显示loading动画
  loadingTimer.push(setTimeout(() => {
    globalLoading.push(Loading.service(loadingCfg))
  }, (new Date().getTime() - loadingTimerLastTimestamp < 17 ? 0 : loadingWaitTime)))
}
// request拦截器
service.interceptors.request.use(
  (config) => {
    // 静默模式
    if (config.silent != 1) {
      progress.start()
    }
    let cfg = config
    let loading = cfg.loading
    let loadingText = cfg.loadingText

    // 添加水印
    addWatermark(cfg)

    // 合并选项，添加loading
    let loadingCfg = _.assign({}, loadingConfig, loadingText ? { text: loadingText } : {})
    if (loading === '1') {
      addLoadingQueue(loading, loadingCfg)
    }
    return cfg
  },
  error => {
    progress.fail()
    log('request error:' + error) // for debug
    return Promise.reject(error)
  }
)

// respone拦截器
service.interceptors.response.use(
  (response) => {
    let resp = response
    let cfg = resp.config
    let data = JSON.stringify(resp.data)
    let headers = resp.headers
    resp.headers = headersKeysLowerCase(resp.headers)
    let parsedData
    /**
     * 关闭接口返回数据验证
     */
    // let ifValidate = true
    // _.each(noValidateUrls, item => {
    //   if (url.indexOf(item) > -1) {
    //     ifValidate = false
    //   }
    // })
    // if ((ifValidate && validateRes(cfg.requestid, headers['client-resid'], data, publicKey)) || !ifValidate) {
    //
    // } else {
    //   Notification({
    //     title: '提示',
    //     message: `抱歉，请求数据异常`,
    //     type: 'error'
    //   })
    // }
    try {
      parsedData = JSON.parse(data)
    } catch (e) {
      parsedData.message = data
      console.log('json parse 数据解析异常：', e)
    }
    if (headers[ACCESS_TOKEN_KEY]) {
      setToken(headers[ACCESS_TOKEN_KEY])
    }
    if (hasPageCount(headers) && isType(parsedData, 'object')) {
      parsedData.totalCount = getTotalCount(headers)
      parsedData.hasNextPage = hasNextPage(headers)
    }
    resp.data = parsedData
    log(`response success: ${cfg.url}\n response.data:`, resp.data)
    processLoading()
    processResponseMessage(resp)
    progress.finish()
    // 获取全部响应数据
    if (cfg.allData === '1') {
      return resp
    } else {
      return resp.data
    }
  },
  error => {
    let err = error
    let resp = err.response
    let cfg = err.config
    progress.fail()
    processLoading()
    processResponseMessage(resp)
    processResponseError(err)
    // 获取全部响应数据
    if (cfg.allData === '1') {
      return Promise.reject(resp)
    } else {
      return Promise.reject(resp.data)
    }
  }
)

export default service
